enum Pagination {
    PAGE_SIZE = 20
}

export default Pagination;